import { useEffect, useRef, useState } from 'react';
import { CustomerProfileModel } from '../../../models/customerProfile';
import axios from '../../../lib/axios';
import { BAN_CUSTOMER } from '../../../lib/endpoints/customer';
import moment from 'moment';
import { convertDateStringToNormalString } from '../../../utils/convertDateFormat';

interface Props {
  selectedProfile: CustomerProfileModel;
  onSelectProfile: Function;
  onClose: VoidFunction;
  onFetchCustomer: any;
}

export const useFormCustomerController = ({
  selectedProfile,
  onSelectProfile,
  onClose,
  onFetchCustomer,
}: Props) => {
  const [banUser, setBanUser] = useState<boolean>(false);
  const [openConfirm, setOpenConfirm] = useState<boolean>(false);
  const [loadingButton, setLoadingButton] = useState<boolean>(false);
  const fullName = useRef<HTMLInputElement>(null!);
  const email = useRef<HTMLInputElement>(null!);
  const phone = useRef<HTMLInputElement>(null!);
  const address = useRef<HTMLInputElement>(null!);
  const dateOfBirth = useRef<HTMLInputElement>(null!);
  const gender = useRef<HTMLInputElement>(null!);
  const job = useRef<HTMLInputElement>(null!);
  const register = useRef<HTMLInputElement>(null!);
  const level = useRef<HTMLInputElement>(null!);

  const handleBanUser = (newValue: boolean) => {
    if (!banUser) {
      setBanUser(newValue);
      setOpenConfirm(true);
    } else {
      setBanUser(newValue);
      setOpenConfirm(true);
    }
  };

  const handleOpenConfirmForm = () => {
    setOpenConfirm(true);
  };

  const handleCloseConfirmForm = () => {
    setOpenConfirm(false);
    if (!banUser) {
      setBanUser(true);
    } else {
      setBanUser(false);
    }
  };

  const handleDateChange = () => {
    const inputDate = selectedProfile?.profile?.dateOfBirth;
    const dateObject = moment(inputDate, 'DD/MM/YYYY');
    const formattedDate = dateObject.format('YYYY-MM-DD');

    return formattedDate;
  };

  const handleReset = () => {
    fullName.current.value = '';
    email.current.value = '';
    phone.current.value = '';
    address.current.value = '';
    dateOfBirth.current.value = '';
    gender.current.value = '';
    job.current.value = '';
    register.current.value = '';
    onSelectProfile(null);
  };

  const handleCredentialUser = async () => {
    try {
      setLoadingButton(true);
      await axios.post(`${BAN_CUSTOMER}`, {
        isBan: banUser,
        userId: selectedProfile.customer.id,
      });
      await onFetchCustomer();
      onClose();
    } catch (err) {
      // console.log('error =', err);
    } finally {
      setLoadingButton(false);
    }
  };

  useEffect(() => {
    if (selectedProfile) {
      fullName.current.value = selectedProfile?.profile.fullName;
      email.current.value = selectedProfile?.customer.email;
      phone.current.value = selectedProfile?.customer.phone;
      address.current.value = selectedProfile?.profile.address;
      dateOfBirth.current.value = convertDateStringToNormalString(
        selectedProfile?.profile?.dateOfBirth
      );
      gender.current.value = selectedProfile?.profile.gender;
      job.current.value = selectedProfile?.profile.occupation;
      register.current.value = selectedProfile?.customer?.phone
        ? 'Phone'
        : selectedProfile?.customer?.appleId
        ? 'Apple Id'
        : selectedProfile?.customer?.googleId
        ? 'Google'
        : selectedProfile?.customer?.facebookId
        ? 'faceBook'
        : selectedProfile?.customer?.email
        ? 'Email'
        : '';
      // level.current.value = selectedProfile?.customer.level;
      setBanUser(selectedProfile?.customer.isBan);
    }
  }, [selectedProfile]);

  return {
    banUser,
    handleBanUser,
    fullName,
    email,
    phone,
    address,
    dateOfBirth,
    gender,
    job,
    register,
    level,
    handleReset,
    handleCredentialUser,
    handleCloseConfirmForm,
    handleOpenConfirmForm,
    openConfirm,
    loadingButton,
  };
};
